import type {FC} from 'react'
import Picker from '@shared/components/base/inputs/Picker'
import {useFilterParams} from '@shared/hooks/useFilterParams'
import {useCustomTranslation} from '@shared/hooks/useCustomTranslation'
import {FILTER_WIDTH} from '@shared/constants/filters'

const AnomalyFilterByStatus: FC = () => {
  const [t] = useCustomTranslation('anomalies')
  const {values, setValue} = useFilterParams({status: {default: 'All'}})

  return (
    <Picker
      label={t('anomaly_feedback_chat.status_string')}
      placeholder={t('anomaly_feedback_chat.status_string')}
      value={values.status}
      onChange={(value) => setValue('status', value)}
      // A fixed set of states: Picker filters its own list, nothing to page.
      options={[
        {id: 'All', name: t('anomaly_feedback_chat.all')},
        {id: 'DETECTED', name: t('anomaly_feedback_chat.detected')},
        {id: 'CLASSIFIED', name: t('anomaly_feedback_chat.classified')},
      ]}
      // "All" is the empty state, so a clear row would say the same thing twice.
      clearable={false}
      // A fixed list of three: the search row is most of the popover and has
      // nothing to search.
      hideSearch
      size="small"
      // Wide enough for the longest value; without a width of its own it
      // collapsed in the header row until the value read as an ellipsis.
      minWidth={FILTER_WIDTH}
      maxWidth={FILTER_WIDTH}
      dataCy="anomaly-status-filter"
    />
  )
}

export default AnomalyFilterByStatus
